export const cartList = () => {
  let carts = localStorage.getItem("cart")
    ? JSON.parse(localStorage.getItem("cart"))
    : null;
  let list = [];
  if (carts !== null) {
    for (let cart of carts) {
      list.push(cart.id);
    }
    return list;
  } else {
    return (list = null);
  }
};

export const updateQuantity = (
  type,
  totalQuantitiy,
  quantitiy,
  setQuantitiy,
  setAlertq
) => {
  if (type === "increase") {
    if (quantitiy === totalQuantitiy) {
      setAlertq(true);
    } else {
      setQuantitiy(quantitiy + 1);
    }
  } else if (type === "decrease") {
    if (quantitiy === 1) {
      setQuantitiy(1);
      setAlertq(false);
    } else {
      setQuantitiy(quantitiy - 1);
    }
  }
};

export const slideImage = (type, active, count, setCount, pImages) => {
  if (active === count) {
    return true;
  }
  if (type === "increase") {
    if (count === pImages.length - 1) {
      setCount(0);
    } else if (count < pImages.length) {
      setCount(count + 1);
    }
  }
};

export const inCart = (id) => {
  if (localStorage.getItem("cart")) {
    let cartProducts = JSON.parse(localStorage.getItem("cart"));
    for (let product of cartProducts) {
      if (product.id === id) {
        return true;
      }
    }
  }
  return false;
};

export const addToCart = async (
  productId,
  quantity,
  price,
  layoutDispatch,
  setQuantity,
  setAlertq,
  fetchData,
  totalCost
) => {
  try {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingShipping = JSON.parse(localStorage.getItem("selectedShipping"));

    // Check for existing product
    const existingItem = cart.find(item => item.id === productId);
    
    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({
        id: productId,
        quantity: quantity,
        price: price
      });
    }

    // Update cart storage
    localStorage.setItem("cart", JSON.stringify(cart));
    
    // Preserve shipping selection
    if (existingShipping) {
      localStorage.setItem("selectedShipping", JSON.stringify(existingShipping));
    }

    // Update UI state
    layoutDispatch({ type: "inCart", payload: cartList() });
    layoutDispatch({ type: "cartTotalCost", payload: totalCost() });
    setQuantity(1);
    setAlertq(false);
    fetchData();
  } catch (error) {
    console.error("Error adding to cart:", error);
  }
};